module.exports = __webpack_public_path__ + "static/media/Strength Magazine Design.baeac9cf.jpg";